module.exports = "/assets/js/b5c5ce955c937d79ac65a3e6a0499d99.svg";